import MuiGrid, {
  GridLegacyProps,
  GridLegacySize,
} from '@mui/material/GridLegacy';
import {
  breakpointIsLargerOrEqual,
  useBreakpointContext,
} from '../../Components/BreakpointContext/BreakpointContextUtils';

/**
 * Kontroll för att skapa en flexibel grid-layout.
 * Just nu precis samma som material-ui grid https://material-ui.com/components/grid/#grid
 */
const EDGrid = (props: GridLegacyProps) => {
  const { spacing, container, xs, sm, md, lg, xl, ...rest } = props;
  const { localBreakPoint } = useBreakpointContext();
  let width: boolean | GridLegacySize | undefined = undefined;
  width = xs ?? width;
  if (breakpointIsLargerOrEqual('sm', localBreakPoint)) {
    width = sm ?? width;
  }
  if (breakpointIsLargerOrEqual('md', localBreakPoint)) {
    width = md ?? width;
  }
  if (breakpointIsLargerOrEqual('lg', localBreakPoint)) {
    width = lg ?? width;
  }
  if (breakpointIsLargerOrEqual('xl', localBreakPoint)) {
    width = xl ?? width;
  }
  if (container) {
    return (
      <MuiGrid
        spacing={spacing == null ? 3 : spacing}
        container
        xs={width}
        {...rest}
      />
    );
  } else {
    return <MuiGrid xs={width} {...rest} />;
  }
};

export default EDGrid;
